(function() {

  let breakoutData = [];
  let chartData = [];
  let gageData = [];

  /**
   * This function is used to bind events to each filter
   * @param  {Object} filterGroup [filterGroup to bind events to]
   */
  function bindFilterEvents(filterGroup) {
    filterGroup.filters.forEach( filter => {
      if ( filter.name === 'date' ) {
        filter.onChange = (e) => {
          const promise = request(udDataUrl).then( json => {
            const filteredData = filterData(json, "upstream-downstream", filter.getDate());
            chart.data = filteredData;
            chart.createUDChart(filteredData);
          });
        };
      } else if ( filter.name === 'start-date' ) {
        filter.onChange = (e) => {
          const promise = request(tsDataUrl).then( json => {
            const filteredData = filterData(json, "time-series", filter.getDate(), filterGroup.filters[1].getDate(), filterGroup.filters[2].val());
            chart.data = filteredData;
            download.setData(filteredData);
            chart.createTSChart(filteredData);
          });
        };
      } else if ( filter.name === 'end-date' ) {
        filter.onChange = (e) => {
          const promise = request(tsDataUrl).then( json => {
            const filteredData = filterData(json, "time-series", filterGroup.filters[0].getDate(), filter.getDate(), filterGroup.filters[2].val());
            chart.data = filteredData;
            download.setData(filteredData);
            chart.createTSChart(filteredData);
          });
        };
      } else if ( filter.name === 'gage' ) {
        filter.onChange = (e) => {
          const promise = request(tsDataUrl).then( json => {
            const filteredData = filterData(json, "time-series", filterGroup.filters[0].getDate(), filterGroup.filters[1].getDate(), filter.val());
            chart.data = filteredData;
            download.setData(filteredData);
            chart.createTSChart(filteredData);
          });
        };
      }
      filter.bindEvents();
    })
  }

  /**
   * This function is used to filter data
   * @param  {array} data  [data to filter]
   * @param  {string} type  [display type i.e. upstream-downstream, time-series]
   * @param  {string} date1 [date to filter data by]
   * @param  {string} date2 [date to filter data by]
   * @param  {string} loc   [location to filter data by]
   * @return {array}       [filtered data]
   */
  function filterData(data, type, date1, date2, loc) {
    if ( type === "upstream-downstream" ) {
      const filteredData = data
        .filter( d => {
          // return d.ddate === date1 && d.reach == 1;
          return d.ddate === date1;
        })
        .map( d => {
          let obj = Object.assign({}, d);
          obj.releases = parseFloat(obj.releases);
          obj.native_flow = parseFloat(obj.native_flow);
          obj.exchanges = parseFloat(obj.exchanges);
          obj.other_admin = parseFloat(obj.other_admin);
          obj.measured_flow = parseFloat(obj.measured_flow);
          obj.display_order = parseInt(obj.measured_flow);
          obj.reach = parseInt(obj.reach);
          return obj;
        })
      return filteredData;
    } else if ( type === "time-series" ) {
      const filteredData = data.filter( d => {
        return (new Date(`${d.ddate} 00:00:00`) >= new Date(`${date1} 00:00:00`) && new Date(`${d.ddate} 00:00:00`) <= new Date(`${date2} 00:00:00`)) && d.location === loc
      });
      return filteredData;
    }
  }

  // Request mock chart data
  async function request(url) {
    const response = await fetch(url);
    const json = await response.json();
    return json;
  }

  // Declare data endpoints
  const udDataUrl = "./sites/all/themes/lrebootstrap/src/php/view/index.php?table=viewer.datasource_up_down&fields%5b%5d=*&drupal_user_switch=false&drupal_userid=1";
  const tsDataUrl = "./sites/all/themes/lrebootstrap/src/php/view/index.php?table=viewer.datasource_timeseries&fields%5b%5d=*&drupal_user_switch=false&drupal_userid=1";
  const tsLocationsUrl = "./sites/all/themes/lrebootstrap/src/php/view/index.php?table=viewer.flowstations_list&fields%5b%5d=*&drupal_user_switch=false&drupal_userid=1";
  const flowLinksUrl = "./sites/all/themes/lrebootstrap/src/php/view/index.php?table=viewer.flowstations_sourcelinks&fields%5b%5d=*&drupal_user_switch=false&drupal_userid=1";
  const breakoutUrl = "./sites/all/themes/lrebootstrap/src/php/view/index.php?table=viewer.datasource_drilldown&fields%5b%5d=*&drupal_user_switch=false&drupal_userid=1";

  // Declare page components
  const sidebar = new Sidebar({ title: "No Selection" });
  const download = new Download();
  const map = Map(sidebar);
  const breakoutTable = new Table({
    name: 'breakout-table',
    container: '#breakout-table-wrapper',
    fields: {
      adate: 'Date',
      avalue: 'Delivery',
      avalue_requested: 'Requested',
      cl_category: 'Category',
      wc_linkstring: 'Transaction Details',
    },
    noDataMessage: 'Only Native Flows in the River',
    rowIndicatorFormatting: {
      cl_category: {
        'Releases': {
          color: '#94ade0'
        },
        'Exchanges': {
          color: '#eb9aeb'
        },
        "BOR Project Water": {
          color: '#ffc6a9'
        }
      }
    }
  });

  breakoutTable.updateTitle = (gage) => {
    const $title = document.querySelector('#breakout-table-title');
    const filteredGageData = gageData.filter(d => d.dwr_id_abbrev === gage)[0];
    $title.textContent = `${filteredGageData.gaged_reach_name} (${gage}) (click on a graph point to view breakout)`;
    return this;
  }

  const today = formatDate(new Date(), 'yyyy-mm-dd');
  let yesterday = new Date();
  yesterday.setDate(yesterday.getDate()-1);
  yesterday = formatDate(yesterday, 'yyyy-mm-dd');
  let monthAgo = new Date();
  monthAgo.setDate(monthAgo.getDate()-31);
  monthAgo = formatDate(monthAgo, 'yyyy-mm-dd');


  // Create the display type feature
  const displayFilter = new Dropdown({
    container: "#display-type-select",
    elementExists: true,
    data: [
      { value: "upstream-downstream", display: "Upstream to Downstream" },
      { value: "time-series", display: "Time Series" }
    ],
    onChange: () => {
      let val = displayFilter.val();
      if ( val === "upstream-downstream" ) {
        download.toggleVisibility(false);
        const promise = request(udDataUrl).then( json => {
          const filteredData = filterData(json, "upstream-downstream", yesterday);
          chart.data = filteredData;
          chart.createUDChart(filteredData);
        });

        udFilters.filters[0].setDate(yesterday);

        udFilters.show();
        tsFilters.hide();

        const $title = document.querySelector('.data-display-title');
        $title.textContent = 'Upstream to Downstream Viewer';
      } else if ( val === "time-series" ) {
        const promise = request(tsDataUrl).then( json => {
          const filteredData = filterData(json, "time-series", monthAgo, yesterday, "ARKPUECO");
          chart.data = filteredData;
          download.setData(filteredData);
          download.toggleVisibility(true);
          chart.createTSChart(filteredData);
        });

        udFilters.hide();
        tsFilters.show();

        const $title = document.querySelector('.data-display-title');
        $title.textContent = 'Time Series Viewer';
      } else {
        udFilters.hide();
        tsFilters.hide();
      }
    }
  });
  // Create upstream to downstream filter group
  const udFilters = new filterGroup({
    name: 'udFilters',
    filterConfigs: [
      {
        name: 'date',
        type: 'date',
        label: 'Date',
        defaultValue: new Date(`${yesterday} 00:00:00`)
      },
      {
        name: 'reach',
        type: 'select',
        label: 'Reach',
        data: [{ value: "1", display: "Arkansas Mainstem" }],
        defaultValue: "1"
      }
    ]
  }).createFilters();
  bindFilterEvents(udFilters);

  // Create time series filter group
  const tsFilters = new filterGroup({
    name: 'tsFilters',
    filterConfigs: [
      {
        name: 'start-date',
        type: 'date',
        label: 'Start Date',
        defaultValue: new Date(`${monthAgo} 00:00:00`)
      },
      {
        name: 'end-date',
        type: 'date',
        label: 'End Date',
        defaultValue: new Date(`${yesterday} 00:00:00`)
      },
      {
        name: 'gage',
        type: 'select',
        label: 'Gage',
        data: [],
        defaultValue: "ARKPUECO"
      }
    ]
  });

  const chart = new Chart(sidebar, map, udFilters, tsFilters, breakoutTable, {});

  const flowLinksTable = new Table({
    name: 'flow-links-table',
    container: '#flow-links-table-wrapper',
    fields: {
      gaged_reach_name: 'Gaged Reach Name',
      dwr_id: 'DWR ID',
    }
  });

  map.addChart(chart);

  const tsLocationsPromise = request(tsLocationsUrl).then((json) => {
    tsFilters.filterConfigs[2].data = json;
    tsFilters.createFilters().hide();
    bindFilterEvents(tsFilters);
  });

  const flowLinksPromise = request(flowLinksUrl).then((json) => {
    flowLinksTable.data = json;
    flowLinksTable.filteredData = json;
    gageData = json;
    flowLinksTable.build();
  });

  const breakoutPromise = request(breakoutUrl);
  const chartPromise = request(udDataUrl);


  // displayFilter.buildDropdown().val("upstream-downstream");
  displayFilter.buildDropdown().val("upstream-downstream");

  // When promises are resolved, prepare the chart data
  Promise.all([breakoutPromise, chartPromise])
    .then((response) => {
      breakoutData = response[0];
      chartData = response[1];

      const filteredData = filterData(chartData, "upstream-downstream", yesterday);
      chart.data = filteredData;
      chart.createUDChart(filteredData);

      breakoutTable.data = breakoutData;
      breakoutTable.filteredData = breakoutData.filter((d) => {
        return d.location === 'ARKPUECO' && d.adate === udFilters.filters[0].getDate();
      });
      breakoutTable.build();
    })
    .catch( err => {
      throw err;
    });
})();
